var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM7.58594 8.60352V7.66016H10.8262V13.0625H12.8945V14H7.58594V13.0625H9.74219V8.60352H7.58594ZM9.75977 6.43555C9.6543 6.31836 9.60156 6.17188 9.60156 5.99609C9.60156 5.90234 9.61523 5.81445 9.64258 5.73242C9.67383 5.65039 9.7207 5.58008 9.7832 5.52148C9.83398 5.4707 9.89844 5.43164 9.97656 5.4043C10.0586 5.37305 10.1504 5.35742 10.252 5.35742C10.3535 5.35742 10.4434 5.37305 10.5215 5.4043C10.5996 5.43164 10.6641 5.4707 10.7148 5.52148C10.7773 5.57617 10.8242 5.64453 10.8555 5.72656C10.8867 5.80859 10.9023 5.89844 10.9023 5.99609C10.9023 6.17188 10.8477 6.31836 10.7383 6.43555C10.6289 6.55273 10.4668 6.61133 10.252 6.61133C10.0332 6.61133 9.86914 6.55273 9.75977 6.43555Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/Info.0da958aea4341050d42fa6eb6112f4c6.svg";
export { ForwardRef as ReactComponent };